export const FormAction = {
    SUBMIT: 'submit',
    RESET: 'reset',
    CANCEL: 'cancel'
};

export const useFormOptions = {
    provide: {
        FORM: '$form'
    },
    props: {
        FIELDS: 'fields',
        URL: 'url',
        ROUTE: 'route',
        EVENT: 'event',
        STORE_FILTERS: 'storeFilters'
    },
    vars: {
        MODEL_ID: 'modelId'
    }
};

export const useFormButtonOptions = {
    inject: {
        FORM: '$form'
    },
    props: {
        ACTION: 'action',
        LABEL: 'label'
    }
};

export const useFormElemOptions = {
    inject: {
        FORM: '$form'
    },
    props: {
        FIELD: 'field',
        DISABLED: 'disabled',
        READONLY: 'readonly'
    }
};

/**
 * @param {import("./form").FormModelFieldValidation} options
 * @return {import("./form").FormModelFieldValidation}
 */
export const formModelFieldValidationFactory = ({ touched = false, errors = [], validators = [] } = {}) => ({
    touched,
    errors,
    validators
});
